// extracted by mini-css-extract-plugin
export default {"page":"MAb3P","wrapperIcon":"nal0A","iconCode":"Q8pdy","contentWrapper":"lTVkH","heading":"riN8D","text":"xMNSf","link":"JM6hf"};